import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const FaqPage = () => {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { window.scrollTo(0, 0); api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (!faqs.length) return;
    const ld = {
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
    };
    const s = document.createElement("script");
    s.type = "application/ld+json"; s.id = "faq-ld"; s.text = JSON.stringify(ld);
    document.head.appendChild(s);
    return () => { document.getElementById("faq-ld")?.remove(); };
  }, [faqs]);

  return (
    <div className="max-w-2xl mx-auto px-6 pt-20 md:pt-28 pb-24" data-testid="faq-page">
      <p className="overline text-gold mb-4">Questions</p>
      <h1 className="font-serif text-5xl md:text-7xl leading-none mb-12">Answered.</h1>
      {faqs.length === 0 && <p className="text-espresso/50">Answers are being prepared.</p>}
      <div className="border-t border-espresso/10">
        {faqs.map((f) => (
          <details key={f.id} className="group py-5 border-b border-espresso/10" data-testid={`faq-item-${f.id}`}>
            <summary className="flex justify-between items-center cursor-pointer list-none font-serif text-xl gap-6">
              {f.question}
              <span className="text-gold text-2xl leading-none transition-transform group-open:rotate-45">+</span>
            </summary>
            <p className="text-espresso/75 leading-loose mt-4 whitespace-pre-line">{f.answer}</p>
          </details>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
